module.exports = __webpack_public_path__ + "img/Course.40c13aff.svg";